import axios from 'axios';
import { mapState } from 'vuex';
import { db } from '@/db';
import { cloudFunctions } from '../config';

export default {
  name: 'match-mixin',

  computed: {
    ...mapState([
      'user_data',
      'playersConnected',
      'trainersConnected',
      'bindUserUnsubscribe',
    ]),

    hasLinks() {
      if (!this.selectedProfile.videolinks) {
        return false;
      }
      const hasLinks = this.selectedProfile.videolinks[0].title !== ''
        || this.selectedProfile.videolinks[1].title !== '';
      return hasLinks;
    },

    hasPictures() {
      return this.selectedProfile.galleryImages
        && this.selectedProfile.galleryImages.length > 0
        && (this.selectedProfile.galleryImages[0] !== ''
        || this.selectedProfile.galleryImages[1] !== ''
        || this.selectedProfile.galleryImages[2] !== ''
        || this.selectedProfile.galleryImages[3] !== '');
    },

    hasArticles() {
      if (!this.selectedProfile.newslinks) {
        return false;
      }
      const hasArticles = this.selectedProfile.newslinks[0].title !== ''
        || this.selectedProfile.newslinks[1].title !== '';
      return hasArticles;
    },
  },

  methods: {
    setMatchChat(selectedProfile, chatId) {
      const name = (!selectedProfile.name || selectedProfile.name === '') ? selectedProfile.team_name : selectedProfile.name;
      let contactDetails = {
        type: selectedProfile.userType,
        nationality: selectedProfile.nationality,
      };

      if (selectedProfile.userType === 'player') {
        contactDetails = {
          ...contactDetails,
          player_position: selectedProfile.position_specific ? selectedProfile.position_specific : selectedProfile.position,
          player_team: (selectedProfile.no_team === true || selectedProfile.no_team === 'nein') ? selectedProfile.currentTeam : 'Vereinslos',
        };
      } else if (selectedProfile.userType === 'teams') {
        contactDetails = {
          ...contactDetails,
          team_league: selectedProfile.category.league,
          team_verband: selectedProfile.verband,
        };
      } else if (selectedProfile.userType === 'trainer') {
        contactDetails = {
          ...contactDetails,
          trainer_type: selectedProfile.trainer_type,
          trainer_team: (selectedProfile.no_team === true || selectedProfile.no_team === 'nein') ? selectedProfile.currentTeam : 'Vereinslos',
        };
      }

      let contactByDetails = {
        type: this.user_data.userType,
        nationality: this.user_data.nationality,
      };

      if (this.user_data.userType === 'teams') {
        contactByDetails = {
          ...contactByDetails,
          team_league: this.user_data.category.league,
          team_verband: this.user_data.verband,
        };
      } else if (this.user_data.userType === 'scout') {
        contactByDetails = {
          ...contactByDetails,
          working_for: this.user_data.working_for,
          search_area: this.user_data.bundesland.length ? this.user_data.bundesland.join(', ') : '',
        };
      }

      return db
        .collection('matches')
        .doc(chatId)
        .set({
          team: this.user_data.team_name,
          player_id: selectedProfile.id,
          player_name: name,
          profile_pic: selectedProfile.big_thumbnail,
          type: selectedProfile.userType,
          chat_id: chatId,
          team_id: this.user_data.id,
          logo: this.user_data.big_thumbnail,
          timestamp: Date.now(),
          contactDetails,
          contactByDetails,
        });
    },

    matchPlayer(selectedProfile, heIs, me) {
      this.$store.state.loading = true;
      this.$store.state.watchUserDataActive = false;
      const chat_id = `${this.$store.state.user_id}${selectedProfile.id}`;
      this.bindUserUnsubscribe();

      this.setMatchChat(selectedProfile, chat_id)
        .then(() => {
          const existingMatches = this.user_data.matches ? this.user_data.matches : [];
          const matchesUpdated = [...existingMatches, chat_id];
          const uniqueMatches = [...new Set(matchesUpdated)];
          this.$store.state.user_data.matches = uniqueMatches;
          return uniqueMatches;
        })
        .then(uniqueMatches => this.updateMyMatches(uniqueMatches, selectedProfile, me, heIs))
        .then(() => this.updateHisMatches(chat_id, selectedProfile, heIs))
        .then(() => this.openChat(selectedProfile, chat_id, me, heIs))
        .then(() => {
          this.$store.state.watchUserDataActive = true;
          this.$store.state.snackText = 'Jetzt kannst du mit deinem Match chatten!';
          this.$store.state.snackbar = true;
          this.$store.dispatch('bindUserData');
          this.$store.state.loading = false;
          this.$emit('close', chat_id);
        })
        .catch((err) => {
          console.log('error matching: ', selectedProfile, heIs, me, chat_id, err);
          this.$store.state.watchUserDataActive = true;
          this.$store.state.loading = false;
        });
    },

    updateMyMatches(uniqueMatches, selectedProfile, collection, heIs) {
      console.log('updateMyMatches', { collection });
      const alreadyMatchetUpdated = this.user_data.already_matched
        ? [...this.user_data.already_matched, selectedProfile.id]
        : [selectedProfile.id];

      this.$store.state.user_data.already_matched = alreadyMatchetUpdated;

      const updateData = {
        already_matched: alreadyMatchetUpdated,
        matches: uniqueMatches,
      };

      // clear last application to disable glowing effect in home button
      if (this.user_data.newApplication && selectedProfile.id === this.user_data.newApplication.id) {
        updateData.newApplication = null;
        this.user_data.newApplication = null;
      }

      if (heIs === 'trainers') {
        const trainerApplicationsUpdated = this.user_data.trainer_applications
          ? this.user_data.trainer_applications.filter(application => application !== selectedProfile.id)
          : [];
        this.$store.state.user_data.trainer_applications = trainerApplicationsUpdated;

        this.$store.state.trainersConnected = this.trainersConnected.filter(p => p && p.id !== selectedProfile.id);
        updateData.trainer_applications = trainerApplicationsUpdated;
      } else if (heIs !== 'scouts') {
        const applicationsUpdated = this.user_data.applications
          ? this.user_data.applications.filter(application => application !== selectedProfile.id)
          : [];
        this.$store.state.user_data.applications = applicationsUpdated;

        this.$store.state.playersConnected = this.playersConnected.filter(p => p && p.id !== selectedProfile.id);
        updateData.applications = applicationsUpdated;
      }

      return db.collection(collection)
        .doc(this.user_data.id)
        .update(updateData);
    },

    updateHisMatches(chat_id, selectedProfile, collection) {
      console.log('updateHisMatches', chat_id);
      return db.collection(collection)
        .doc(selectedProfile.id)
        .get({ source: 'server' })
        .then((snapshot) => {
          const user = snapshot.data();
          let { matches } = user;
          matches = matches || [];

          const matchesUpdated = [...matches, chat_id];
          // newMatchId set to chat_id to show bubble in contacted player/team/trainer profile
          // will be set to null if player/team/trainer opened chat
          // newMatch field will be not used any more

          // const newMatch = user.newMatch || user.newMatch === 0
          //   ? user.newMatch += 1
          //   : 1;
          // return { matchesUpdated, newMatch };
          return { matchesUpdated };
        })
        .then(data => db.collection(collection)
          .doc(selectedProfile.id)
          .update({
            newMatchId: chat_id,
            matches: data.matchesUpdated,
          }))
        .then(async () => {
          await this.sendPushMessage(collection, selectedProfile.id);
        });
    },

    async sendPushMessage(recieverCollection, recieverId) {
      console.log('send push message', recieverCollection, recieverId);
      const recieverData = await db.collection(recieverCollection)
        .doc(recieverId)
        .get()
        .then(snapshot => snapshot.data());

      // send email if allowed or if user didn't login after feature deployed and it's should be default true
      if (recieverData.messagingEmailMatch || recieverData.messagingEmailMatch === undefined) {
        axios({
          method: 'post',
          url: `${cloudFunctions}/sendNotificationEmail`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data: {
            email: recieverData.email,
            name: recieverData.name || recieverData.team_name,
            type: 'match',
            senderType: this.user_data.userType,
          },
        });
      }

      if (recieverData.messagingToken && recieverData.messagingPush && recieverData.messagingPushMatch) {
        console.log('messaging token exists: ', recieverData.messagingToken);
        axios({
          method: 'post',
          url: `${cloudFunctions}/sendPushMessage`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data: {
            data: {
              title: 'Neues Match',
              body: '⚽️ Volltreffer! Du hast ein neues Match! ✅',
              longTitle: 'Neues Match',
              longText: '⚽️ Volltreffer! Du hast ein neues Match! ✅ Gehe jetzt in deinen Account, um mit deinem Match zu chatten. 📲',
              icon: 'https://www.chance4talents.app/img/icons/android-chrome-192x192.png',
            },
            token: recieverData.messagingToken,
          },
        });
      }

      if (recieverData.safariToken && recieverData.messagingPush && recieverData.messagingPushMatch) {
        console.log('safari token exists: ', recieverData.safariToken);
        axios({
          method: 'post',
          url: `${cloudFunctions}/sendNotificationSafari`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data: {
            type: 'match',
            deviceId: recieverData.safariToken,
          },
        });
      }
    },

    async openChat(selectedProfile, chat_id, me, heIs) {
      console.log('openChat', { me }, { heIs });
      const name = (!selectedProfile.name || selectedProfile.name === '') ? selectedProfile.team_name : selectedProfile.name;

      const updateInput = {
        timestamp: Date.now(),
        chat: [],
        logo: this.user_data.big_thumbnail,
        type: selectedProfile.userType,
        team_name: me === 'teams' ? this.user_data.team_name : this.user_data.name,
        profile_pic: selectedProfile.big_thumbnail,
        player_id: selectedProfile.id,
        player_name: name,
      };

      // if (me === 'scouts') {
      //   console.log('inside scouts');
      //   updateInput = {
      //     ...updateInput,
      //     team_name: this.user_data.name,
      //   };

      //   // if (heIs === 'teams' || heIs === 'trainers') {
      //   //   console.log('teams or trainers');
      //   //   updateInput.logo = this.user_data.logo;
      //   // }
      // }

      await db.collection('messages')
        .doc(chat_id)
        .set(updateInput);

      this.redirectToChat(chat_id);
    },

    redirectToChat(id, avatar, contactName, contactedBy) {
      this.$router.push({
        name: 'chat',
        params: {
          id, avatar, contactName, contactedBy,
        },
      });
    },
  },
};
